import devConfig from '../../config/config.dev.json';
import stageConfig from '../../config/config.stage.json';
import prodConfig from '../../config/config.prod.json';

/**
 * Selects the right config file based on REACT_APP_ENV, exactly like
 * chefsteps-ui selects between config.dev.json / config.stage.json / config.prod.json
 * using NEXT_PUBLIC_APP_ENV in next.config.js.
 *
 * Set REACT_APP_ENV in your .env.local:
 *   REACT_APP_ENV=development  → config.dev.json
 *   REACT_APP_ENV=stage        → config.stage.json
 *   REACT_APP_ENV=production   → config.prod.json
 *
 * Falls back to production if not set.
 */
const env = process.env.REACT_APP_ENV || 'production';

const configMap = {
  development: devConfig,
  stage: stageConfig,
  production: prodConfig,
} as const;

export const appConfig = configMap[env as keyof typeof configMap] ?? prodConfig;

const NON_PRODUCTION_ENVS = ['development', 'stage'];

/**
 * Demo/UAT escape hatch — skips the Auth0 + StudioPass VIP gate locally.
 * brg-consumer-assistant already accepts unauthenticated sessions, so no
 * extra signal is sent. Allowlisted to development/stage only, so a stray
 * REACT_APP_BYPASS_VIP=true can never open this gate when REACT_APP_ENV is
 * production, unset, or an unrecognized value (all of which resolve to
 * prodConfig above).
 *   REACT_APP_BYPASS_VIP=true in .env / .env.local
 */
export const isAuthBypassed = NON_PRODUCTION_ENVS.includes(env) && process.env.REACT_APP_BYPASS_VIP === 'true';
